import React from 'react'

const ConvenienceIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={60}
                height={60}
                x={0}
                y={0}
                viewBox="0 0 507.975 507.975"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className=""
            >
                <g>
                    <path
                        d="M403.2 67.837h-382c-11.7 0-21.2 9.5-21.2 21.2v397.7c0 11.7 9.5 21.2 21.2 21.2h382c11.7 0 21.2-9.5 21.2-21.2v-397.7c0-11.7-9.5-21.2-21.2-21.2z"
                        style={{}}
                        fill="#1975c9"
                        data-original="#f2705b"
                        className=""
                        opacity={1}
                    />
                    <path
                        d="M390.5 104.637v355.1c0 7.9-6.4 14.3-14.2 14.3H120.4l-86.6-86.6v-282.8c0-7.9 6.4-14.3 14.3-14.3h328.2c7.8 0 14.2 6.4 14.2 14.3z"
                        style={{}}
                        fill="#f2f2f2"
                        data-original="#f2f2f2"
                        className=""
                    />
                    <path
                        d="M308 35.937h-59.9c0-19.8-16.1-35.9-35.9-35.9s-35.9 16.1-35.9 35.9h-59.9c-8.8 0-16 7.2-16 16v69.9H324v-69.9c0-8.9-7.2-16-16-16zm-95.8 19.2c-10.6 0-19.2-8.6-19.2-19.2s8.6-19.2 19.2-19.2 19.2 8.6 19.2 19.2-8.6 19.2-19.2 19.2z"
                        style={{}}
                        fill="#41596b"
                        data-original="#41596b"
                    />
                    <path
                        d="M308 35.937h-59.9c0-19.8-16.1-35.9-35.9-35.9s-35.9 16.1-35.9 35.9h-59.9c-8.8 0-16 7.2-16 16v11.3c0-8.8 7.2-16 16-16h59.9c0-19.8 16.1-35.9 35.9-35.9s35.9 16.1 35.9 35.9H308c8.8 0 16 7.2 16 16v-11.3c0-8.9-7.2-16-16-16z"
                        style={{ opacity: "0.5", enableBackground: "new" }}
                        fill="#334a5e"
                        data-original="#334a5e"
                    />
                    <path
                        d="M109.8 387.437H33.9l86.6 86.6v-75.9c-.1-6-4.8-10.7-10.7-10.7z"
                        style={{}}
                        fill="#65c5b8"
                        data-original="#65c5b8"
                    />
                    <path
                        d="M64.3 153.137H193v20.4H64.3z"
                        style={{}}
                        fill="#ffd05c"
                        data-original="#ffd05c"
                        className=""
                    />
                    <path
                        d="M64.3 217.337h300v20.4h-300zM64.3 281.437H324v20.4H64.3zM64.3 345.637h257.4v20.4H64.3z"
                        style={{}}
                        fill="#89d6f7"
                        data-original="#89d6f7"
                        className=""
                    />
                    <path
                        d="m500.4 160.637-38.9-38.9c-10.1-10.1-26.4-10.1-36.4-.1l-215.7 215.8-10 57.5-5.8 33.5 33.5-5.8 57.6-9.9 215.7-215.7c10.1-10 10.1-26.3 0-36.4z"
                        style={{}}
                        fill="#abb2b9"
                        data-original="#abb2b9"
                        className=""
                    />
                    <path
                        d="M370.482 152.235h92.299v106.599h-92.299z"
                        style={{}}
                        transform="rotate(134.999 416.634 205.534)"
                        fill="#cdd5df"
                        data-original="#cdd5df"
                    />
                    <path
                        d="M239.427 300.129h58.799v106.599h-58.799z"
                        style={{}}
                        transform="rotate(134.999 268.829 353.43)"
                        fill="#cdd5df"
                        data-original="#cdd5df"
                    />
                    <path
                        d="m429.7 153.337-12 12 12.5 12.5-70.8 70.8c-3.6 0-7.2 1.4-9.9 4.1-5.5 5.5-5.5 14.4 0 19.9s14.4 5.5 19.9 0c2.7-2.7 4.1-6.3 4.1-9.9l70.8-70.8 12.5 12.5 12-12-39.1-39.1z"
                        style={{}}
                        fill="#ffffff"
                        data-original="#ffffff"
                    />
                    <path
                        d="m227.2 422.637-33.5 5.8 5.8-33.5z"
                        style={{}}
                        fill="#334a5e"
                        data-original="#334a5e"
                    />
                </g>
            </svg>

        </>
    )
}

export default ConvenienceIcon